import { connect } from 'react-redux';
import { withObservation } from '@cian/component-observer';
import { sendTeaserEvent, ITeaserEventProps } from '../../../../../browser/utils/TeaserEvent';
import { IAppState } from '../../../../common/state';

import { BannerServicePlaceInternal, IBannerServicePlaceInternalProps } from './index';

export const mapStateToProps = (state: IAppState) => {
  return {
    soprApi: state.soprApi,
    deviceType: state.deviceType,
    userGADataLayerData: state.userGADataLayerData,
    currentPageNumber: state.filters.jsonQuery.page ? state.filters.jsonQuery.page.value : 1,
    servicePlaceWidgetMarkups: state.servicePlaceWidgetMarkups,
    observerKey: state.results.queryString,
    queryString: state.results.queryString,
  };
};

export const getServicePlaceWidgetName = (position: number) => {
  switch (position) {
    case 2:
      return 'servisnoe_mesto_oldstyle_3_show';
    case 32:
      return 'servisnoe_mesto_oldstyle_33_show';
    case 62:
      return 'servisnoe_mesto_oldstyle_63_show';
    default:
      return '';
  }
};

export const transformProps = (props: IBannerServicePlaceInternalProps) => ({
  soprApi: props.soprApi || '',
  user_id: (props.userGADataLayerData && props.userGADataLayerData.realtyUserId) || null,
  pagenumber: props.currentResultPageNumber || 1,
  position: props.position || 1,
  pageType: 'Listing',
  device_type: props.deviceType || '',
  ab_group: (props.userGADataLayerData && props.userGADataLayerData.abGroup) || null,
  block_type: 'mortgage_widget',
  sc: props.queryString || '',
  name: getServicePlaceWidgetName(props.position),
});

export const getTeaserProps = ({
  props,
  isViewed,
}: {
  props: IBannerServicePlaceInternalProps;
  isViewed: boolean;
}): ITeaserEventProps => ({
  ...transformProps(props),
  isTeaserShow: isViewed ? 1 : 0,
});

export const observerOptions = {
  onChange: (events: Array<{ props: IBannerServicePlaceInternalProps; isViewed: boolean }>) =>
    sendTeaserEvent(events.map(getTeaserProps)),
};

export const ObservableBannerServicePlace = connect(mapStateToProps)(
  withObservation<IBannerServicePlaceInternalProps>(BannerServicePlaceInternal, observerOptions),
);
